import { Card, CardBody, Col, Input, Label, Row, Table } from "reactstrap";
import SweetAlert from 'sweetalert2';
import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import useVentesListe, { cardMouvement, changeStatus, deleteVentes, useMvtListe } from "../VenteApi";
import { SearchTableButton } from "../../../utils/Constant";
import { formatDate, formatPhoneNumber, formatPrice, truncateText } from "../../../utils/helper/helpers";
import { Btn } from "../../../AbstractElements";
import { Link } from "react-router-dom";

type Mvts = { [key: string]: any }

const RHMouvement = () => {

    const [filterText, setFilterText] = useState("");
    const [selectedMonth, setSelectedMonth] = useState<number | null>(null);
    const [filteredItems, setFilteredItems] = useState<Mvts[]>([]);
    const [refresh, setRefresh] = useState(false);
    const mouvement = useMvtListe(refresh) || [];

    const handleMonthChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const value = e.target.value;
        setSelectedMonth(value ? parseInt(value) : null);
    };

    useEffect(() => {
        const currentMonth = new Date().getMonth() + 1; // Mois actuel (1-12)
        let filtered = mouvement;
        filtered = mouvement.filter((item) => {
            const itemMonth = new Date(item.date_mouvement).getMonth() + 1;
            const matchesMonth = selectedMonth ? itemMonth === selectedMonth : itemMonth === currentMonth;
            const matchesSearch = item.immatriculation && item.immatriculation.toLowerCase().includes(filterText.toLowerCase()) ||
                item.libelle && item.libelle.toLowerCase().includes(filterText.toLowerCase()) ||
                item.type_mouvement && item.type_mouvement.toLowerCase().includes(filterText.toLowerCase()) ||
                item.date_mouvement && item.date_mouvement.toLowerCase().includes(filterText.toLowerCase());
            return matchesMonth && matchesSearch;
        });

        setFilteredItems(filtered);
    }, [mouvement, filterText, selectedMonth, refresh]);

    return (
        <>
            {
                cardMouvement({ value: filteredItems })
            }
            <Card>
                <CardBody>
                    <Row>
                        <Col sm="9">
                            <div className="dataTables_filter d-flex align-items-center">
                                <Label className="me-2">{SearchTableButton}:</Label>
                                <Input
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
                                    type="search"
                                    value={filterText}
                                />
                            </div>
                        </Col>
                        <Col sm="3">
                            <Input name="type" value={selectedMonth || ''} onChange={handleMonthChange} type="select" className="form-control">
                                <option value="">Mois actuel</option>
                                <option value="1">Janvier</option>
                                <option value="2">Février</option>
                                <option value="3">Mars</option>
                                <option value="4">Avril</option>
                                <option value="5">Mai</option>
                                <option value="6">Juin</option>
                                <option value="7">Juillet</option>
                                <option value="8">Août</option>
                                <option value="9">Septembre</option>
                                <option value="10">Octobre</option>
                                <option value="11">Novembre</option>
                                <option value="12">Décembre</option>
                            </Input>
                        </Col>
                    </Row>
                </CardBody>
                <Table responsive id="all-invoice" striped={true}>
                    <thead className="bg-info">
                        <tr>
                            <th className="text-white">Id</th>
                            <th className="text-white ps-4">Produits</th>
                            <th className="text-white ">Prix Unitaire</th>
                            <th className="text-white ">Quantite</th>
                            <th className="text-white ">Prix Total</th>
                            <th className="text-white ">Type de mouvement</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredItems.map((item, index) => (
                            <tr key={item.id} className='text-center'>
                                <th scope='row'>
                                    <span className="fw-bold">
                                        #{index + 1}
                                    </span>
                                </th>
                                <td style={{ textAlign: "center" }}>
                                    <span className="fw-bold text-capitalize">
                                        {item.libelle}
                                    </span>
                                </td>
                                <td style={{ textAlign: "center" }}>
                                    <span className="fw-bold text-capitalize">
                                        {formatPrice(item.prix_unitaire)}

                                    </span>
                                </td>
                                <td style={{ textAlign: "center" }}>
                                    <span className="fw-bold text-capitalize">
                                        {parseFloat(item.quantite).toLocaleString("gn-GN")}

                                    </span>
                                </td>
                                <td style={{ textAlign: "center" }}>
                                    <span className="fw-bold text-capitalize">
                                        {formatPrice(item.prix_unitaire * item.quantite)}

                                    </span>
                                </td>

                                <td>
                                    {
                                        item.type_mouvement === 'sortie' ? (
                                            <Btn disabled className="btn btn-xs btn-danger">
                                                {item.type_mouvement}
                                            </Btn>
                                        ) : (
                                            <Btn disabled className="btn btn-xs btn-success">
                                                {item.type_mouvement}
                                            </Btn>
                                        )
                                    }

                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Card>
        </>

    )
}

export default RHMouvement